<template>
  <div class="kChart" v-loading="loading">
    <ul class="headerList">
      <div :class="{ leadList: stepList == 1 && !initType }">
        <li>
          <label class="tit">标的:</label>
          <p>
            <span class="titCen"
              >{{ getKsubject.symbol }}-{{ getKsubject.name }}</span>
            <el-button size="small" @click="symbolfun('symbol')">更换标的</el-button>
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 1 && !initType"
          style="right: -106px; top: 27px"
        >
          <img src="../../assets/image/lead1.png" />
          <h3>请选择标的名称</h3>
        </div>
      </div>
      <li>
        <label class="tit">时间:</label>
        <p>
          <span class="titCenData"
            >{{ headerData.startDate }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
              headerData.endDate
            }}</span
          >
        </p>
      </li>
      <div :class="{ leadList: stepList == 2 && !initType }">
        <li>
          <label class="tit">因子:</label>
          <p style="padding-left: 15px">
            <span class="titCen">{{ dataTOList.factor_name }}</span>
            <el-button
              size="small" 
              @click="symbolfun('divisor')"
              style="margin-left: 10px"
              >更换因子</el-button
            >
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 2 && !initType"
          style="right: -97px; top: 24px"
        >
          <img src="../../assets/image/lead1.png" />
          <h3>请选择因子名称</h3>
        </div>
      </div>
    </ul>
    <!-- k线图 -->
    <!-- <Card v-loading="loading"></Card> -->
    <template v-if="initType">
      <div class="box-card shadow" style="position: relative">
        <masterEchart
          :getData="getData"
          :homeTitle="getKsubject.name"
          :startTime="startTime"
          @onZoomInit="echartInit"
          :endTime="endTime"
          :getKlineData="getKlineList"
          :typeName="false"
          ref="kdata"
        ></masterEchart>
        <div class="cardBox" v-if="stepList == 3 && stepType <= newGuideIdx">
          <h3>向下划动滚轮查看更长时间行情数据</h3>
          <p class="cardBox_p">
            <label class="cardBox_lab1">
              <label class="cardBox_lab2"></label>
            </label>
          </p>
        </div>
      </div>
      <div class="shadow" style="background: #fff; margin-top: 20px">
        <el-table
          :data="tableData.slice((currentPage - 1) * 20, currentPage * 20)"
          style="width: 100%"
        >
          <el-table-column prop="date" label="日期"></el-table-column>
          <el-table-column prop="value" label="因子值"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleSizeChange"
            :current-page.sync="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </template>
    <!-- 标的弹窗 -->
    <subject
      :headerData="subjectData"
      ref="subject"
      @onSucceed="onSucceed"
      :typeSel="false"
      :symbolVisible="symbolType"
      :getKsubject="getKsubject"
    ></subject>
    <!-- 因子的弹窗 -->
    <divisor
      :headerData="headerData"
      ref="divisor"
      @onSucceed="divisorSucceed"
      :symbolVisible="masterType"
      :getKsubject="dataTOList"
    ></divisor>
    <!-- 指引 -->
    <template v-if="stepType <= newGuideIdx">
      <div class="leadBox"></div>
      <!-- <div class="skip" @click="stepType='null'">跳过</div> -->
      <!-- <div class="nextStep">
        <template v-if="getKsubject.symbol && stepList == 1">
          <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
          <el-button type="primary" v-if="stepList != 2" @click="stepList++"
            >下一步</el-button
          >
          <el-button type="primary" v-else @click="onload">完成</el-button>
        </template>
        <template v-else-if="dataTOList.factor_name">
          <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
          <el-button type="primary" v-if="stepList != 2" @click="stepList++"
            >下一步</el-button
          >
          <el-button type="primary" v-else @click="onload">完成</el-button>
        </template>
      </div> -->
    </template>
  </div>
</template>
<script>
import masterEchart from "@/views/factorAnalysis/common/echarts/masterEchart.vue";
import subject from "@/components/subjectDialog/subject.vue"; // 标的弹窗
import divisor from "@/components/subjectDialog/divisor.vue"; // 更换因子弹窗
import TimeUtil from "@/util/TimeUtil.js";
export default {
  components: { subject, divisor, masterEchart },
  data() {
    return {
      // 新手指引
      stepList: 1, // 步数
      stepType: 0, // 记录进入次数
      newGuideIdx: this.$store.state.newGuideIdx, // 限制次数
      initType: false,

      currentPage: 1,
      total: 0,
      loading: false,
      tableData: [],
      startTime: "0",
      endTime: "25",
      // 标的
      getKsubject: {}, // 已选择标的数据

      getdivisor: {},
      // 主图指标
      dataTOList: {}, // 已选择数据
      masterType: false,
      // 获取k线对应指标,每次获取一个，操作方式为循环添加
      getKlineList: [],
      paramType: "0",
      symbolType: false,
      masterVisible: false,
      headerData: {},
      subjectData: {},
      getData: [],
      // K线图
      getKdataTo: {
        endDate: "", // 數據結束時間
        exchange: "", // 市場
        frequency: "day.1", // 频率: m.1, m.5, m.30, m.60, d.1, d.w, d.m day.month
        reinstatement: "na", // 复权,na,fward,bward
        startDate: "", // 數據開始時間
        symbol: "", // 标的
      },
      // 获取k线对应指标
      getKLinedata: {
        getKDataTO: {
          endDate: "",
          exchange: "",
          frequency: "day.1",
          reinstatement: "na",
          startDate: "",
          symbol: "",
        },
        indexName: "", // 指标名稱
      },
      // 单标因子
      symbolparam: {
        endDate: "2019-12-31 00:00:00",
        factorName: "pb",
        marketSymbol: "sse.600519",
        startDate: "2016-01-01 00:00:00",
      },
    };
  },
  methods: {
    // 完成
    onload() {
      this.initType = true;
      this.stepType = "null";
      this.getSymbolData();
      this.getKData();
    },
    // 新手指引
    localGet() {
      if (JSON.parse(localStorage.getItem("singlefactor"))) {
        this.stepType = Number(localStorage.getItem("singlefactor"));
        const webSizeIdx = Number(localStorage.getItem("singlefactor")) + 1;
        localStorage.setItem("singlefactor", webSizeIdx);
      } else {
        localStorage.setItem("singlefactor", 1);
      }
    },
    handleSizeChange(val) {
      this.currentPage = val;
    },
    // 因子弹窗
    divisorSucceed(item, type) {
      this.masterType = false;
      if (type) {
        this.dataTOList = this.headerData.factorInfoTOList.filter(
          (items) => items.factor_no == item
        )[0];
        this.symbolparam.factorName = item;
       
        if (this.stepList == 2) {
          this.onload();
        } else {
 // 初始化
        this.getSymbolData();
        }
      }
    },
    echartInit(item) {
      this.startTime = item.start.toString();
      this.endTime = item.end.toString();
      this.$nextTick(() => {
        if(this.$refs.kdata){
            this.$refs.kdata.echartsInit();
          }
        // this.$refs.kdata.echartsInit();
      });
    },
    // 主图指标
    // onMaster(item, type) {
    //   this.masterType = false;
    //   if (type) {
    //     this.dataTOList = item;
    //     if (this.stepList == 2) {
    //       this.onload();
    //     } else {
    //       // 初始化
    //       this.getKLineIndex();
    //     }
    //   }
    // },
    // 标的保存
    onSucceed(item, type) {
      this.symbolType = false;
      if (type) {
        
        this.getKsubject = item;
        // 标的参数
        this.getKdataTo.exchange = item.exchange;
        this.getKdataTo.symbol = item.symbol;
        // 因子表格
        this.symbolparam.marketSymbol = item.exchange + "." + item.symbol;
        // 初始化
        if (this.stepList == 1) {
          this.stepList++;
        }else{
          this.getSymbolData();
          this.getKData();
        }
       
      }
    },
    // 弹窗
    symbolfun(type) {
      if (type == "divisor") {
        // 更换因子
        this.masterType = true;
      } else if (type == "symbol") {
        // 标的
        this.symbolType = true;
        this.$refs.subject.selectBtn(this.getKsubject); // 默认显示第一个
      }
      // this.getKLineIndex();
    },
    // 初始化参数
    getIndexParam() {
      this.loading = true;
      this.$api.hubei.getSingleFactorParams().then((res) => {
        this.loading = false;
        if (res) {
          this.headerData = res;
          this.subjectData = res;
          // this.getKsubject = res.codeDataTOList[0]; // 标的
          // this.dataTOList = res.factorInfoTOList[0]; // 因子
          this.symbolparam.factorName = res.factorInfoTOList[0].factor_no; // 因子id
          // this.dataTOList.push(res.dataPropertyTOList[0]); // 主图指标
          this.symbolparam.marketSymbol =
            res.codeDataTOList[0].exchange + "." + res.codeDataTOList[0].symbol;
          this.symbolparam.endDate = res.endDate;
          this.symbolparam.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 11) + "18:00:00"; // res.startDate;
          // K线图
          this.getKdataTo.endDate = res.endDate;
          this.getKdataTo.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 11) + "18:00:00"; //res.startDate;
          this.getKdataTo.exchange = res.codeDataTOList[0].exchange;
          this.getKdataTo.symbol = res.codeDataTOList[0].symbol;
          this.$nextTick(() => {
            this.$refs.subject.ngOnInit();
            this.$refs.divisor.ngOnInit();
            // this.loading = false;
            // this.$refs.mastermap.ngOnInit();
          });
          // 获取k线图
          this.getKData();
          this.getSymbolData();
        }
      });
    },
    // 获取主图
    getKData() {
      const than = this;
      this.loading = true;
      this.$api.hubei.getKData(this.getKdataTo).then((res) => {
        this.loading = false;
        than.getData = res.kDataTOList || [];
        this.$nextTick(() => {
          if(this.$refs.kdata){
            this.$refs.kdata.echartsInit();
          }
        });
      });
    },
    // 因子表格
    getSymbolData() {
      this.loading = true;
      this.$api.hubei.getSymbolData(this.symbolparam).then((res) => {
        this.loading = false;
        const arrayLi = Object.keys(res.listHashMap);
        if (arrayLi.length > 0) {
          let getAttr = [];
          this.tableData = [];
          // for (const itemtoLIST of this.dataTOList) {
          for (const index of arrayLi) {
            getAttr = getAttr.concat(res.listHashMap[index]);
          }
          this.tableData = this.tableData.concat(getAttr);
          this.total = this.tableData.length;
        }
      });
    },
  },
  created() {
    this.getIndexParam();
    // this.localGet();
    this.$ILab.StartStep("singlefactor")
  },
};
</script>
<style lang="less" scoped>
.active {
  color: #fff;
  background: rgba(63, 152, 241, 1);
  border-radius: 4px;
  font-size: 14px;
}
.kChart {
  position: relative;
  .headerList {
    li {
      font-size: 14px;
      color: #666666;
      margin-bottom: 20px;
      font-family: MicrosoftYaHei;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
      .tit {
        color: #3f98f1;
        width: 64px;
        line-height: 30px;
        line-height: 34px;
      }
      > span {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .titCenData {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .titCen {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        color: #333333;
        font-size: 14px;
      }
      // .titCen:hover {
      //   color: #fff;
      //   background: rgba(63, 152, 241, 1);
      //   border-radius: 4px;
      //   font-size: 14px;
      // }
    }
  }
}
.box-card {
  height: 600px;
}
// 弹窗
.symbolDialog {
  .tit {
    color: #3f98f1;
    display: inline-block;
    width: 64px;
    line-height: 34px;
  }
  .symbolDiaUl {
    li {
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
    }
  }
  /deep/ .el-dialog__header {
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
  }
}
/deep/ .el-table th {
  color: #666666;
  background: #f0f2f5;
  text-align: center;
}
/deep/ .el-table td {
  text-align: center;
  color: #666666;
}
/deep/ .el-table td,
/deep/ .el-table th {
  padding: 8px 0;
}
.pagination {
  text-align: right;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-top: none;
}
.shadow {
  box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
}

// 新手指引
.leadBox {
  margin-left: -16px;
  background: rgba(51, 51, 51, 0.3);
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
}
.cardBox {
  position: absolute;
  left: 172px;
  z-index: 10;
  bottom: 84px;
  color: #fff;
  font-size: 24px;
}
.leadList {
  position: relative;
  z-index: 9;
  background: #ffffff;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 10px 0 10px;
  // pointer-events: none;
  .digBox {
    position: absolute;
    right: -225px;
    z-index: 10;
    top: 44px;
    color: #fff;
    font-size: 24px;
    h3 {
      margin-left: -119px;
    }
  }
}
.skip {
  position: absolute;
  right: 12%;
  top: 91px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
.nextStep {
  position: absolute;
  font-size: 21px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  left: 500px;
  top: 30%;
}
.cardBox_p {
  width: 37px;
  height: 85px;
  background: #ffffff;
  border-radius: 33px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
  padding-top: 14px;
  .cardBox_lab1 {
    width: 17px;
    height: 36px;
    border-radius: 9px;
    border: 1px solid #979797;
    display: block;
  }
  .cardBox_lab2 {
    width: 14px;
    height: 14px;
    background: #d8d8d8;
    display: block;
    border-radius: 100%;
  }
}
</style>
